import { Box, useTheme } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import FontAwesome from 'react-fontawesome';

interface Props {
  isDragActive: boolean;
  overlay?: boolean;
}

const DropzoneOverlay: React.FC<Props> = ({ isDragActive, overlay }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        '& .fa': {
          fontSize: '3rem',
        },
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...(overlay && {
          backgroundColor: theme.palette.transparent.light85,
          borderStyle: 'dashed',
          borderWidth: '1px',
          bottom: 0,
          left: 0,
          minHeight: '6em',
          position: 'absolute',
          right: 0,
          top: 0,
          zIndex: theme.zIndexOverlay,
        }),
      }}
    >
      <FontAwesome name="cloud-upload" />
      {isDragActive ? t('form.dropzone.hover') : t('form.dropzone.passive')}
    </Box>
  );
};

export default DropzoneOverlay;
